import React from "react";
import { Link } from "react-router-dom";

function Redirect({ setShowModal }) {
  //modal styling
  const modalStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
    fontSize: "1.5rem",
    display: "flex",
    flexDirection: "column",
    fontFamily: "Butler, Butler Stencil, Averta ",
  };

  const modalContentStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "5px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
    textAlign: "center",
    padding: "2rem",
    display: "flex",
    gap: "1rem",
    flexDirection: "column",
  };

  const linkStyle = {
    display: "inline-block",
    textDecoration: "none",
    color: "#007bff",
    fontWeight: "bold",
    marginRight: "20px",
  };

  const buttonStyle = {
    padding: "10px 20px",
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background 0.3s",
  };
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div style={modalStyle}>
      <div style={modalContentStyle}>
        <p>Would you like to explore the live code?</p>
        <Link
          href="https://github.com/jclairelee/liv_client"
          style={linkStyle}
          target="_blank"
          rel="noopener noreferrer"
        >
          Explore GitHub
        </Link>
        <button style={buttonStyle} onClick={closeModal}>
          Close
        </button>
      </div>
    </div>
  );
}

export default Redirect;
